import pixAxios from '@/axios/pixAxios.js';
import store from '@/store/index.js';
import asyncUtils from '@/services/common/async.utils.js';

const urlJobApi = 'https://apigea.qrmjll.com/pixv2apisbx/api/Job/';
const suscriptionKeyValue = '30e72d4f8c444a99bd3e0cc434d7caf6';
const headers = {
  'Ocp-Apim-Subscription-Key': suscriptionKeyValue,
  'Subscription-Key': suscriptionKeyValue,
};

export default {
  //Review. Failed to test due to 401 error from endpoint getPropertiesByJobId
  getMandate: (jobId, includeProperty = true, includeClientsContact = true) => {
    return pixAxios
      .get(
        `${urlJobApi}GetJobById`,
        {
          params: {
            jobId,
            includeProperty,
            includeClientsContact,
          },
        },
        { headers }
      )
      .then(({ data }) => {
        data.Properties = data?.Groups.flatMap(({ Properties }) => Properties);
        return data;
      });
  },

  // Review OK
  advancedSearchJob: (body) => {
    return asyncUtils
      .asyncDebounce(async () => {
        store.dispatch('loadingOverlayModule/setIsLoading', true);
        return await pixAxios.post(`${urlJobApi}AdvancedSearchJob`, body, { headers });
      }, 1000)
      .then(({ data }) => {
        store.dispatch('loadingOverlayModule/setIsLoading', false);
        return data;
      });
  },

  //Review. Failed to test due to 401 error from endpoint getPropertiesByJobId
  updateMandate: (body) => {
    return pixAxios.put(`${urlJobApi}UpdateJobDetails`, body, { headers }).then(({ data }) => data);
  },

  // Review. Error 500. "Cannot insert the value NULL into column 'RefNumber', table 'PIXv2.dbo.JobClientInfo'; column does not allow nulls. UPDATE fails."
  // The endpoint must be verified in the backend, since passing it a random value does not work either.
  // View mandateAddMandate.vue, Line 83.
  // In the api change the InternalJobReference attribute corresponds to RefNumber
  addMandate: (body) => {
    return pixAxios.post(`${urlJobApi}AddJob`, body, { headers }).then(({ data }) => data);
  },

  // Review OK
  duplicateMandate: (body) => {
    return pixAxios.post(`${urlJobApi}DuplicateJob`, body, { headers }).then(({ data }) => data);
  },

  //Review. Error 401
  getPropertiesByJobId: (paginationConfig, JobRowId, TextSearch) => {
    return asyncUtils
      .asyncDebounce(async () => {
        store.dispatch('loadingOverlayModule/setIsLoading', true);
        return await pixAxios.post(
          `${urlJobApi}SearchPropertiesOfJob`,
          {
            ...paginationConfig,
            JobRowId,
            TextSearch,
          },
          { headers }
        );
      }, 1000)
      .then(({ data }) => {
        store.dispatch('loadingOverlayModule/setIsLoading', false);
        return data;
      });
  },
};
